import { useCallback, useState } from 'react';

import { useApolloClient } from '@apollo/client/react';

import { useAppData } from '@modules/_shared/providers/AppDataProvider';
import { emitFeedRefresh } from '@modules/_shared/utils/feed-refresh';
import { GET_USER_MODULE_HISTORY } from '@modules/users/userQueries';

export const useRefreshMeAfterModuleGrant = (userId: string) => {
  const { me, refetchMe } = useAppData();
  const client = useApolloClient();
  const [refreshError, setRefreshError] = useState<Error | null>(null);

  const onModuleGrantCompleted = useCallback(() => {
    emitFeedRefresh();
    void Promise.all([
      client.refetchQueries({
        include: [GET_USER_MODULE_HISTORY],
        onQueryUpdated: query =>
          query.variables.id === userId ? query.refetch() : false,
      }),
      ...(userId === me?.id ? [refetchMe()] : []),
    ]).catch(error => {
      setRefreshError(
        error instanceof Error ? error : new Error(String(error)),
      );
    });
  }, [client, me?.id, refetchMe, userId]);

  const resetRefreshError = useCallback(() => {
    setRefreshError(null);
  }, []);

  return { onModuleGrantCompleted, refreshError, resetRefreshError };
};
